module.exports = __webpack_public_path__ + "static/img/image_02@2x.679990b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/KtbTrio/image_02@2x.png
// module id = xHVw
// module chunks = 69